export default __webpack_public_path__ + "static/media/growup_img.6cfe1cdd.png";